import { put, select, takeLatest } from 'redux-saga/effects';
import { selectScopedSiteID } from 'reduxStore/app/selectors';
import { ttlockActions } from './slice';
import { settingsActions } from 'reduxStore/settings/slice';
import { Notification } from 'zComponents/atoms';

export function* triggerSync() {
	const superFetchModule = yield import('library/helpers/superFetch');
	const superFetch = superFetchModule.default;
	try {
		// Files this run's audit rows under the picked site; null keeps them org-wide.
		const siteID = yield select(selectScopedSiteID);
		const res = yield superFetch.post(`/ttlock/sync`, { siteID });
		if (res.statusCode === 200) {
			// Reload settings so the Sync TTLock flag (122) + Last Sync (121)
			// reflect the queued sync immediately.
			yield put(settingsActions.loadOrgSettings());
			yield put(ttlockActions.triggerSyncSuccess());
		} else {
			// The server error field is a STRING on handled errors, but an OBJECT
			// ({statusCode, message}) on 404/failsafe responses — extract a real
			// message either way (never '[object Object]').
			const message =
				typeof res.error === 'string'
					? res.error
					: res.error?.message || res.message || 'Failed to trigger TTLock sync.';
			throw new Error(message);
		}
	} catch (error) {
		// The server enumerates EVERY missing setting in one message
		// (module off / TTLock Account not set / no groups configured).
		Notification('error', error.message || 'Failed to trigger TTLock sync.');
		yield put(ttlockActions.triggerSyncError(error.message));
	}
}

export default function* ttlockSagas() {
	yield takeLatest(ttlockActions.triggerSync, triggerSync);
}
